export interface SubscriptionInterface {
    state: string;
}

export interface FormGetInterface {
    securityUpdateSubscribed: boolean;
    machineNumber: string;
    machineName: string;
}
